import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { v4 as uuidv4 } from "uuid";

// Uploads a file and returns its download URL
export async function uploadImageFile(file, folder = "deity_icons") {
  const storage = getStorage();
  const fileRef = ref(storage, `${folder}/${uuidv4()}_${file.name}`);
  await uploadBytes(fileRef, file);
  return await getDownloadURL(fileRef);
}